import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=1afa9bcc&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=1afa9bcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afa9bcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1afa9bcc')) {
      api.createRecord('1afa9bcc', component.options)
    } else {
      api.reload('1afa9bcc', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=1afa9bcc&scoped=true&", function () {
      api.rerender('1afa9bcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4ROmaAxIODAfs/JS/comp/GuestBox.vue"
export default component.exports